/**
 *
 * @param {*} bytesSize
 * @returns
 */
export function bytesSizeFormat(bytesSize) {
  const units = ['bytes', 'KB', 'MB', 'GB', 'TB']
  const factor = 1024
  let size = bytesSize
  let unidadIndex = 0

  while (size > factor) {
    size /= factor
    unidadIndex++
  }

  return `${size.toFixed(0)} ${units[unidadIndex]}`
}
